module.exports = __webpack_public_path__ + "img/top.68171367.png";